export default __webpack_public_path__ + "pdf/what-now-csv-guide_0dcfa04f0d35ebb40b34df40b93bb41f.pdf";